// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .info {
  margin-bottom: 20px;
}
:host .list {
  min-width: 600px;
  height: 400px;
  font-size: 16px !important;
  padding-top: 0px !important;
  overflow: auto;
}
:host .list-header {
  display: block;
  height: 20px !important;
}
:host .list-header span {
  text-overflow: ellipsis;
  overflow: hidden;
  color: gray;
  font-size: 12px;
}
:host .list-item {
  display: block;
  font-size: 14px;
  height: 40px !important;
  /* cursor: pointer; */
  overflow: hidden;
}
:host .list-item .list-type {
  width: 160px;
}
:host .list-item .list-name {
  width: 200px;
}
:host .list-item .list-version {
  width: 100px;
}
:host .list-item .list-description {
  width: 260px;
}
:host .list-item .list-status {
  width: 200px;
}
:host .list-item .list-tool {
  display: flex;
  min-width: 120px;
}
:host .list-item span {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
:host .list-item-text {
  text-overflow: ellipsis;
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/app/editor/plugins/plugins.component.scss","webpack://./../../../../%E6%9D%AD%E5%B7%9E%E6%95%B0%E7%BA%B3%E5%B7%9D/IccpPlatform/fuxa/client/src/app/editor/plugins/plugins.component.scss"],"names":[],"mappings":"AAEI;EACI,mBAAA;ACDR;ADGI;EACI,gBAAA;EACA,aAAA;EACA,0BAAA;EACA,2BAAA;EACA,cAAA;ACDR;ADII;EACI,cAAA;EACA,uBAAA;ACFR;ADIQ;EACI,uBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;ACFZ;ADMI;EACI,cAAA;EACA,eAAA;EACA,uBAAA;EACA,qBAAA;EACA,gBAAA;ACJR;ADMQ;EACI,YAAA;ACJZ;ADMQ;EACI,YAAA;ACJZ;ADMQ;EACI,YAAA;ACJZ;ADMQ;EACI,YAAA;ACJZ;ADMQ;EACI,YAAA;ACJZ;ADMQ;EACI,aAAA;EACA,gBAAA;ACJZ;ADMQ;EACI,mBAAA;EACA,uBAAA;EACA,gBAAA;ACJZ;ADQI;EACI,uBAAA;EACA,gBAAA;ACNR","sourcesContent":["\n:host {\n    .info {\n        margin-bottom: 20px;;\n    }\n    .list {\n        min-width: 600px;\n        height: 400px;\n        font-size: 16px !important;\n        padding-top: 0px !important;\n        overflow: auto;\n    }\n\n    .list-header {\n        display: block;\n        height: 20px !important;\n\n        span {\n            text-overflow: ellipsis;\n            overflow: hidden;\n            color: gray;\n            font-size: 12px;\n        }\n    }\n\n    .list-item {\n        display: block;\n        font-size: 14px;\n        height: 40px !important;\n        /* cursor: pointer; */\n        overflow: hidden;\n\n        .list-type {\n            width:160px;\n        }\n        .list-name {\n            width:200px;\n        }\n        .list-version {\n            width:100px;\n        }\n        .list-description {\n            width:260px;\n        }\n        .list-status {\n            width:200px;\n        }\n        .list-tool {\n            display: flex;\n            min-width:120px;\n        }\n        span {\n            white-space: nowrap;\n            text-overflow: ellipsis;\n            overflow: hidden;\n        }\n    }\n\n    .list-item-text {\n        text-overflow: ellipsis;\n        overflow: hidden;\n    }\n}",":host .info {\n  margin-bottom: 20px;\n}\n:host .list {\n  min-width: 600px;\n  height: 400px;\n  font-size: 16px !important;\n  padding-top: 0px !important;\n  overflow: auto;\n}\n:host .list-header {\n  display: block;\n  height: 20px !important;\n}\n:host .list-header span {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  color: gray;\n  font-size: 12px;\n}\n:host .list-item {\n  display: block;\n  font-size: 14px;\n  height: 40px !important;\n  /* cursor: pointer; */\n  overflow: hidden;\n}\n:host .list-item .list-type {\n  width: 160px;\n}\n:host .list-item .list-name {\n  width: 200px;\n}\n:host .list-item .list-version {\n  width: 100px;\n}\n:host .list-item .list-description {\n  width: 260px;\n}\n:host .list-item .list-status {\n  width: 200px;\n}\n:host .list-item .list-tool {\n  display: flex;\n  min-width: 120px;\n}\n:host .list-item span {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n:host .list-item-text {\n  text-overflow: ellipsis;\n  overflow: hidden;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
